import CrmAPI from '../../api/crm';

export const state = {
  board: null,
  dashboard: null,
  pipelines: [],
  uiFlags: {
    isFetching: false,
    isFetchingDashboard: false,
    isSaving: false,
    isDeleting: false,
  },
};

export const getters = {
  getBoard: $state => $state.board,
  getDashboard: $state => $state.dashboard,
  getPipelines: $state => $state.pipelines,
  getUIFlags: $state => $state.uiFlags,
};

export const actions = {
  fetchDashboard: async ({ commit }, params = {}) => {
    commit('setUIFlag', { isFetchingDashboard: true });
    try {
      const response = await CrmAPI.getDashboard(params);
      commit('setDashboard', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isFetchingDashboard: false });
    }
  },
  fetchPipelines: async ({ commit }) => {
    const response = await CrmAPI.getPipelines();
    commit('setPipelines', response.data);
    return response.data;
  },
  fetchBoard: async ({ commit }, params = {}) => {
    commit('setUIFlag', { isFetching: true });
    try {
      const response = await CrmAPI.getBoard(params);
      commit('setBoard', response.data);
      return response.data;
    } finally {
      commit('setUIFlag', { isFetching: false });
    }
  },
  createPipeline: async ({ commit }, payload) => {
    commit('setUIFlag', { isSaving: true });
    try {
      const response = await CrmAPI.createPipeline(payload);
      return response.data;
    } finally {
      commit('setUIFlag', { isSaving: false });
    }
  },
  createDeal: async ({ commit }, payload) => {
    commit('setUIFlag', { isSaving: true });
    try {
      const response = await CrmAPI.createDeal(payload);
      return response.data;
    } finally {
      commit('setUIFlag', { isSaving: false });
    }
  },
  updateDeal: async ({ commit }, { dealId, payload }) => {
    commit('setUIFlag', { isSaving: true });
    try {
      const response = await CrmAPI.updateDeal(dealId, payload);
      return response.data;
    } finally {
      commit('setUIFlag', { isSaving: false });
    }
  },
  deleteDeal: async ({ commit }, dealId) => {
    commit('setUIFlag', { isDeleting: true });
    try {
      await CrmAPI.deleteDeal(dealId);
    } finally {
      commit('setUIFlag', { isDeleting: false });
    }
  },
};

export const mutations = {
  setUIFlag($state, flags) {
    $state.uiFlags = { ...$state.uiFlags, ...flags };
  },
  setBoard($state, payload) {
    $state.board = payload.pipeline;
    $state.pipelines = payload.pipelines || [];
  },
  setDashboard($state, dashboard) {
    $state.dashboard = dashboard;
  },
  setPipelines($state, pipelines) {
    $state.pipelines = pipelines;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
